import {
  AdminSpinner,
  Button,
  Div,
  H5,
  Img,
  Modal,
  PropsModal,
  ProviderLogoWrapper,
  connectLocationWithPos,
  renderPosImage,
  renderPosName,
  useIsIOSSafari,
  useSafeWindowOpen,
  reportError,
} from '@vgrubs/components';
import { PosType } from 'components/src/types/api/location.types';
import { useState } from 'react';

export const PosConnectModal = ({
  modalIsOpen,
  closeModal,
  id,
  provider,
  pathPrefix,
  getProvidersStatuses,
}: PropsModal & {
  modalIsOpen: boolean;
  provider: PosType;
  id: string | number;
  pathPrefix: 'locations' | 'brands';
  getProvidersStatuses: (silent?: boolean, buttonLoading?: boolean) => void;
}) => {
  const openSafe = useSafeWindowOpen();
  const isIOSSafari = useIsIOSSafari();
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState<{ url: string; isNewTab: boolean } | null>(
    null
  );
  const localhost = true;

  const handleRedirect = (url: string, isNewTab: boolean) => {
    openSafe(url, {
      immediate: true,
      target: isNewTab ? '_blank' : '_self',
    });

    closeModal?.();
    setUrl(null);
  };

  async function handleConnect() {
    try {
      setLoading(true);
      const res = await connectLocationWithPos(id, {
        provider,
        redirectUrl: `${
          localhost ? process.env.NX_ADMIN_URL : window.location.origin
        }/${pathPrefix}/manage-pos/${id}?cp=${provider}`,
      });

      const url = res.data.data;

      if (isIOSSafari) {
        setUrl({
          url,
          isNewTab: true,
        });
      } else {
        handleRedirect(url, true);
      }

      getProvidersStatuses(true);
    } catch (error) {
      setLoading(false);
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <AdminSpinner />}

      <Modal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        logo={false}
        header="Connect Provider"
      >
        <Div $flex $center>
          <ProviderLogoWrapper>
            <span>
              <Img alt="" src={renderPosImage(provider)} />
            </span>
          </ProviderLogoWrapper>
        </Div>

        <>
          {!url && (
            <H5 $mb="16">
              Click on button to connect POS {renderPosName(provider)} with our
              app
            </H5>
          )}
          {url && (
            <H5 $mb="16">You will be redirected to authorization page</H5>
          )}
        </>

        {!url && (
          <Button $selected $w="100%" $mt="16" onClick={() => handleConnect()}>
            Connect
          </Button>
        )}

        {url && (
          <Button
            $selected
            $w="100%"
            $mt="16"
            onClick={() => handleRedirect(url.url, url.isNewTab)}
          >
            Proceed to authorization page
          </Button>
        )}
      </Modal>
    </>
  );
};
